var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2050,
    height: 250,
    viewBox: "0 0 2050 250",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 146 125)",
    id: "frV1R8_AC3qTseYjuDG1G"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-115, -115)",
    d: "M 0 0 L 230 0 L 230 230 L 0 230 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 403.92 125)",
    id: "xudkxR6qVPPDcZHpFLai2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 646.03 124.8)",
    id: "fKOxgwxRY9ZP8R2CNcEUR"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 897.61 125.2)",
    id: "EpQ6F23AWRB5bvXfuJcSX"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 1155.5 131.52)",
    id: "2D2s4qMHF5CB2bDqphCDV"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 1399.71 131.52)",
    id: "SILW-5NdYQ-UlBiQGnCqq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 1650.24 131.52)",
    id: "5SLmzbWxpREvQnSPBVL_5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 1896.56 124.8)",
    id: "orrGhHhMvFK06LBqlDpJ8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(73,56,109)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -115 -115 L 115 -115 L 115 115 L -115 115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1025 125)",
    id: "olr6YcJc2ccB3Pd8pJo9F"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -878.61 0)",
    id: "nLJ3hnh6nT5r8m3AqOCo_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,170,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1370, -1430)",
    d: "M 220 1430 L 220 280 L 2520 280 L 2520 2580 L 220 2580 L 220 1430 z M 1237 1732 C 1311 1443 1361 1257 1366 1248 C 1378 1228 1390 1259 1444 1465 C 1475 1581 1510 1707 1521 1745 C 1532 1784 1544 1825 1547 1838 C 1552 1859 1557 1860 1659 1860 L 1765 1860 L 1817 1647 C 1846 1531 1892 1338 1920 1220 C 1947 1102 1974 990 1979 973 L 1988 940 L 1889 940 C 1772 940 1782 930 1750 1085 C 1738 1140 1718 1237 1704 1300 C 1690 1363 1675 1437 1669 1465 C 1656 1531 1643 1542 1635 1494 C 1631 1472 1602 1352 1570 1225 C 1539 1099 1510 982 1506 967 L 1499 939 L 1378 942 L 1257 945 L 1217 1095 C 1195 1178 1163 1299 1146 1364 C 1129 1430 1110 1485 1104 1487 C 1098 1489 1084 1448 1071 1388 C 1059 1331 1035 1222 1019 1145 C 1002 1068 983 990 977 973 L 966 940 L 768 940 L 775 973 C 779 990 827 1195 881 1427 C 935 1659 980 1851 980 1854 C 980 1857 1031 1860 1093 1860 L 1205 1860 L 1237 1732 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 123.33 0)",
    id: "MqT66WGyIaL2gnt8Vijii"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(199,180,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8890, -1430)",
    d: "M 7740 1430 L 7740 280 L 10040 280 L 10040 2580 L 7740 2580 L 7740 1430 z M 9250 1780 L 9250 1700 L 8790 1700 L 8790 940 L 8590 940 L 8590 1860 L 9250 1860 L 9250 1780 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 377.87 0)",
    id: "v1B1z-WBpMLePbCNBCxwz"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(199,180,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3870, -3930)",
    d: "M 2720 3930 L 2720 2780 L 5020 2780 L 5020 5080 L 2720 5080 L 2720 3930 z M 4250 4280 L 4250 4200 L 3729 4200 L 3732 4083 L 3735 3965 L 3963 3962 L 4190 3960 L 4190 3800 L 3729 3800 L 3732 3703 L 3735 3605 L 3983 3602 L 4230 3600 L 4230 3440 L 3530 3440 L 3530 3885 C 3531 4130 3533 4337 3536 4345 C 3541 4358 3593 4360 3896 4360 L 4250 4360 L 4250 4280 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 626.6 0)",
    id: "VqmQyTsmuwxsH_X6fZieL"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(119,123,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11390, -8930)",
    d: "M 10240 8930 L 10240 7780 L 12540 7780 L 12540 10080 L 10240 10080 L 10240 8930 z M 11752 9300 L 11752 9225 L 11500 9220 L 11249 9215 L 11249 9100 L 11248 8985 L 11477 8980 L 11705 8975 L 11705 8825 L 11477 8820 L 11248 8815 L 11248 8625 L 11494 8622 L 11740 8620 L 11740 8460 L 11050 8460 L 11050 9380 L 11401 9378 L 11752 9375 L 11752 9300 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -626.02 0)",
    id: "Wie0oPUuu5lVWlYMqp-eX"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(119,123,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6380, -6430)",
    d: "M 5220 6430 L 5220 5280 L 7540 5280 L 7540 7580 L 5220 7580 L 5220 6430 z M 6582 6863 C 6703 6806 6780 6711 6816 6575 C 6834 6510 6834 6329 6816 6263 C 6772 6096 6655 5983 6493 5950 C 6462 5943 6393 5940 6340 5942 C 6252 5945 6236 5949 6167 5983 C 6006 6063 5930 6203 5930 6420 C 5930 6582 5973 6703 6060 6784 C 6154 6872 6238 6900 6400 6897 C 6506 6895 6520 6892 6582 6863 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -625.97 -1.05)",
    id: "qevlWdis6K5f24f7N7POq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(119,123,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6380.49, -6419.48)",
    d: "M 6307 6726 C 6287 6718 6255 6701 6236 6686 C 6200 6659 6150 6571 6150 6534 C 6150 6521 6147 6509 6142 6507 C 6117 6491 6141 6287 6176 6219 C 6206 6159 6311 6100 6386 6100 C 6428 6100 6516 6140 6547 6172 C 6586 6214 6599 6240 6616 6309 C 6663 6505 6581 6699 6438 6730 C 6376 6743 6354 6742 6307 6726 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -376.95 0)",
    id: "xQBH2XcDelZtsk3WMxp_9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(119,123,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8890, -6430)",
    d: "M 7740 6430 L 7740 5280 L 10040 5280 L 10040 7580 L 7740 7580 L 7740 6430 z M 8710 6689 L 8710 6497 L 8760 6503 C 8824 6511 8877 6536 8893 6566 C 8911 6600 9070 6831 9093 6858 C 9112 6878 9122 6880 9227 6880 C 9289 6880 9340 6877 9340 6874 C 9340 6852 9163 6595 9112 6543 C 9061 6491 9053 6478 9067 6473 C 9174 6437 9222 6397 9249 6324 C 9290 6216 9264 6091 9189 6026 C 9121 5968 9070 5960 8772 5960 L 8510 5960 L 8510 6880 L 8710 6880 L 8710 6689 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -377.56 -19.88)",
    id: "dMADH85YbpplqRnX5K6lw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(119,123,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8883.93, -6231.23)",
    d: "M 8708 6235 C 8706 6156 8708 6126 8717 6123 C 8743 6113 8986 6126 9011 6139 C 9051 6159 9070 6206 9056 6254 C 9037 6322 9012 6332 8851 6338 L 8711 6343 L 8708 6235 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -126.66 0)",
    id: "HgXdWopG_FwTddllmQD-K"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,170,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11390, -1430)",
    d: "M 10240 1430 L 10240 280 L 12540 280 L 12540 2580 L 10240 2580 L 10240 1430 z M 11531 1844 C 11655 1808 11734 1724 11775 1587 C 11796 1517 11795 1299 11774 1217 C 11746 1108 11667 1011 11571 967 C 11529 947 11504 945 11268 942 L 11010 939 L 11010 1860 L 11243 1860 C 11427 1860 11488 1857 11531 1844 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 -125.63 -2.85)",
    id: "YWrHyPpFLGFh4I7h4hxZQ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,170,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11400.34, -1401.5)",
    d: "M 11210 1401 L 11210 1100 L 11277 1100 C 11370 1100 11470 1119 11504 1143 C 11520 1154 11544 1188 11558 1219 C 11596 1300 11602 1459 11570 1557 C 11533 1673 11503 1690 11328 1698 L 11210 1703 L 11210 1401 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 877.61 0)",
    id: "M8mlfimbJqKpcV26Oq6mA"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,170,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6380, -1430)",
    d: "M 5220 1430 L 5220 280 L 7540 280 L 7540 2580 L 5220 2580 L 5220 1430 z M 6210 1670 L 6210 1480 L 6236 1480 C 6278 1480 6347 1501 6367 1520 C 6377 1530 6426 1597 6475 1670 C 6618 1880 6592 1860 6726 1860 C 6789 1860 6840 1857 6840 1854 C 6840 1832 6663 1575 6612 1522 C 6577 1487 6550 1457 6552 1456 C 6554 1455 6574 1448 6597 1442 C 6710 1409 6774 1312 6767 1185 C 6762 1102 6737 1045 6684 1002 C 6619 948 6564 940 6272 940 L 6010 940 L 6010 1860 L 6210 1860 L 6210 1670 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 0.1 877.89 -22.03)",
    id: "AITClNl7jIm4vOkML-sJJ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,170,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6382.78, -1209.73)",
    d: "M 6208 1214 C 6206 1136 6208 1106 6217 1103 C 6243 1093 6486 1106 6512 1119 C 6563 1145 6575 1240 6532 1282 C 6509 1305 6421 1320 6303 1320 L 6211 1320 L 6208 1214 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f28c54e0b73179951db5da50c359adf.svg";
export { ForwardRef as ReactComponent };